// "Talent Navigator" is a non-negotiable, always-appended part of every
// dashboard title — stripped here so callers can offer just the client/project-
// specific portion for editing without duplicating or losing the suffix.
// The legacy "Workforce Reinvention" / "Work Reinvention" suffix is still
// stripped so dashboards saved before this rename keep formatting correctly.
const SUFFIX = 'Talent Navigator'
const LEGACY_SUFFIX_PATTERN = /Work(?:force)?\s+Reinvention/i
const SUFFIX_PATTERN = /Talent\s+Navigator/i

export function getDashboardBaseName(name: string): string {
  const trimmed = name.trim()
  // The generic suffix strip below requires a preceding base + whitespace, so a
  // name that is *only* the suffix (no base at all) needs its own check.
  if (new RegExp(`^(?:${SUFFIX_PATTERN.source}|${LEGACY_SUFFIX_PATTERN.source})$`, 'i').test(trimmed)) return ''
  return trimmed
    .replace(new RegExp(`(?:\\s+(?:${SUFFIX_PATTERN.source}|${LEGACY_SUFFIX_PATTERN.source}))+$`, 'i'), '')
    .trimEnd()
}

export function formatDashboardTitle(name: string): string {
  const baseName = getDashboardBaseName(name)

  return baseName
    ? `${baseName} ${SUFFIX}`
    : SUFFIX
}